import { useMemo } from 'react';
import { useGetAgentCenter } from 'services/hooks/queries';

export const useFetchAgentCenterData = () => {
    // Fetch agent center data on component mount
    const { agentCenterData, isAgentCenterLoading, ...rest } = useGetAgentCenter();

    const formatedAgentCenterData = useMemo(() => {
        if (!agentCenterData) return [];

        const lc = agentCenterData.leadCategorization;
        return [
            {
                label: 'Deal Closed - Lost',
                count: lc.lostDeals,
                colorClass: 'red',
            },
            {
                label: 'Needs follow up',
                count: lc.followUp,
                colorClass: 'yellow',
            },
            {
                label: 'Awaiting docs',
                count: lc.awaitingDocs,
                colorClass: 'purple',
            },
            {
                label: 'Disqualified leads',
                count: lc.disqualifiedLeads,
                colorClass: 'teal',
            },
        ];
    }, [agentCenterData]);

    return {
        agentCenterData,
        formatedAgentCenterData,
        loading: isAgentCenterLoading,
        error: rest.error,
    };
};
